import { useEffect, useState } from 'react'

import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom'
import styled from 'styled-components'
import { useAppDispatch } from '../store/hooks'
import { toggleTheme } from '../store/reducer/ui'

import Homepage from './page/homepage/Homepage'

import Details from './page/detail/Details'
import Header from './component/shared/header/Header'
import Footer from './component/shared/footer/Footer'

const Main = styled.div`
    margin: 48px 0;
`
export function App() {
    const [router, setRouter] = useState<ReturnType<typeof createBrowserRouter> | null>(null)
    const dispatch = useAppDispatch()

    useEffect(() => {
        const isCiat = location.pathname.includes('/ciat')
        const isCarrier = location.pathname.includes('/carrier')
        const basename = isCiat ? '/ciat' : '/carrier'
        // Redirect to carrier , when no model is selected
        if (!isCiat && !isCarrier) {
            window.location.href = '/carrier'
        }


        if (isCiat) {
            dispatch(toggleTheme())
        }
        const Layout = () => (
            <div>
                <Header />
                <Main>
                    <Outlet />
                </Main>
                <Footer />
            </div>
        )

        setRouter(
            createBrowserRouter(
                [
                    {
                        path: '/',
                        element: <Layout />,
                        children: [
                            {
                                index: true,
                                element: <Homepage />,
                            },
                            {
                                path: 'model/:selectedModel',
                                element: <Details />,
                            },
                        ],
                    },
                ],
                {
                    basename,
                }
            )
        )
    }, [])

    return (
        <>
            {router && <RouterProvider {...{ router }} />}
        </>
    )
}
